import React from 'react';
import logo from '../assets/logo--footer.png';
import {Link} from "react-router";
import {FaInstagram} from "react-icons/fa";

function Footer() {
    const year = new Date().getFullYear()
    return (
        <footer
            className="footer-area bg-img"
            style={{backgroundImage: "url(../assets/images/thumb/footer-bid.png)"}}
        >
            <div className="container footer-top py-60">
                <div className="row justify-content-center gy-5">
                    <div className="col-xl-3 col-sm-6">
                        <div className="footer-item">
                            <div className="footer-item__logo">
                                <Link to="/" reloadDocument>
                                    {" "}
                                    <img src={logo} alt="Audiotime" style={{width:"227px", height:"55px"}} />
                                </Link>
                            </div>
                            <p className="footer-item__desc" style={{color:'white'}}>
                                Türkiye'nin en büyük radio networkü.
                            </p>
                            <ul className="social-list style-two">
                                <li className="social-list__item">
                                    <a href="https://www.instagram.com/audiotimedigital/" className="social-list__link" target="_blank">
                                        <FaInstagram/>
                                    </a>{" "}
                                </li>

                                <li className="social-list__item">
                                    <a href="https://www.linkedin.com/company/auditime-media/" className="social-list__link" target="_blank">
                                        {" "}
                                        <span className="icon-linkedin"/>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-3 col-sm-6">
                        <div className="footer-item">
                            <h5 className="footer-item__title">Alt menü</h5>
                            <ul className="footer-menu">
                                <li className="footer-menu__item">
                                    {" "}
                                    <span className="footer-menu__item-icon">
                <span className="icon-next-8"/>
              </span>{" "}
                                    <Link to="/" className="footer-menu__link" reloadDocument>
                                        Ana Sayfa{" "}
                                    </Link>
                                </li>
                                <li className="footer-menu__item">
                                    {" "}
                                    <span className="footer-menu__item-icon">
                <span className="icon-next-8"/>
              </span>{" "}
                                    <Link to="/hakkimizda" className="footer-menu__link" reloadDocument>
                                        Hakkımızda{" "}
                                    </Link>
                                </li>
                                <li className="footer-menu__item">
                                    {" "}
                                    <span className="footer-menu__item-icon">
                <span className="icon-next-8"/>
              </span>{" "}
                                    <Link to="/dijital-network" className="footer-menu__link" reloadDocument>
                                        Dijital Network{" "}
                                    </Link>
                                </li>
                                <li className="footer-menu__item">
                                    {" "}
                                    <span className="footer-menu__item-icon">
                <span className="icon-next-8"/>
              </span>{" "}
                                    <Link to="/hedefleme-seceneklerimiz" className="footer-menu__link" reloadDocument>
                                        Hedefleme Seçeneklerimiz{" "}
                                    </Link>
                                </li>
                                <li className="footer-menu__item">
                                    {" "}
                                    <span className="footer-menu__item-icon">
                <span className="icon-next-8"/>
              </span>{" "}
                                    <Link to="/iletisime-gecin" className="footer-menu__link" reloadDocument>
                                        İletişime Geçin{" "}
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-3 col-sm-6">
                        <div className="footer-item">
                            <h5 className="footer-item__title">Yapay Zeka</h5>
                            <ul className="footer-menu">
                                <li className="footer-menu__item">
                                    {" "}
                                    <span className="footer-menu__item-icon">
                <span className="icon-next-8"/>
              </span>{" "}
                                    <Link to="/giris" className="footer-menu__link" reloadDocument>
                                        Demo Girişi{" "}
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </div>
                    {/*<div className="col-xl-3 col-sm-6">*/}
                    {/*    <div className="footer-item">*/}
                    {/*        <h5 className="footer-item__title">download our apps</h5>*/}
                    {/*        <ul className="download-list">*/}
                    {/*            <li className="download-list__item">*/}
                    {/*                <a*/}
                    {/*                    href="https://play.google.com/store/games?hl=en&gl=US"*/}
                    {/*                    className="download-list__link w-100"*/}
                    {/*                >*/}
                    {/*                    <div className="download-list__icon">*/}
                    {/*                        <img src="assets/images/icons/play-icon.png" alt=""/>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="download-list__content">*/}
                    {/*                        <span className="download-list__subtitle">Available On</span>*/}
                    {/*                        <span className="download-list__title">Google Store</span>*/}
                    {/*                    </div>*/}
                    {/*                </a>*/}
                    {/*            </li>*/}
                    {/*            <li className="download-list__item">*/}
                    {/*                <a*/}
                    {/*                    href="https://www.apple.com/app-store/"*/}
                    {/*                    className="download-list__link w-100"*/}
                    {/*                >*/}
                    {/*                    <div className="download-list__icon">*/}
                    {/*                        <img src="assets/images/icons/apple.png" alt=""/>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="download-list__content">*/}
                    {/*                        <span className="download-list__subtitle">Available On</span>*/}
                    {/*                        <span className="download-list__title">Apple Store</span>*/}
                    {/*                    </div>*/}
                    {/*                </a>*/}
                    {/*            </li>*/}
                    {/*        </ul>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
            {/* bottom Footer */}
            <div className="bottom-footer pb-3">
                <div className="container">
                    <div className="row gy-3">
                        <div className="col-md-12 text-center">
                            <div className="bottom-footer-text text-white">
                                {" "}
                                Copyright © {year}, Audiotime.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

    );
}

export default Footer;